import { render, staticRenderFns } from "./drupal-file.vue?vue&type=template&id=16d4d88e&"
import script from "./drupal-file.vue?vue&type=script&lang=js&"
export * from "./drupal-file.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports